import React, { useEffect, useState } from "react";
import api from "../api";
import innerBanner from "../../assets/images/banner/inner-banner.jpg";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const PublicDisclosure = ({ fetchDepartments, fetchDepartmentData }) => {
  const { i18n, t } = useTranslation();
  const [departments, setDepartments] = useState([]);

  const fetchDeptDatas = async () => {
    try {
      const response = await api.get(`/public_disclosure?language_code=${i18n.language}`);
      const filteredDepartments = response.data.filter(
        (department) => department.status === 1
      );
      setDepartments(filteredDepartments);
    } catch (error) {
      console.error("Error fetching department data:", error);
      alert("Failed to fetch department data. Please try again later.");
    }
  };

  useEffect(() => {
    fetchDeptDatas();
  }, [i18n.language]);

  return (
    <>
      <section className="page-title">
        <div
          className="bg-layer"
          style={{ backgroundImage: `url(${innerBanner})` }}
        ></div>
        <div className="line-box">
          <div className="line-1"></div>
          <div className="line-2"></div>
        </div>
        <div className="auto-container">
          <div className="content-box">
            <h1>{t("publicDisclosure")}</h1>
            <ul className="bread-crumb clearfix">
              <li>
                <Link to="/">{t("home")}</Link>
              </li>
              <li>
                <span>{t("publicDisclosure")}</span>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <div id="main-content">
        <br />
        <section className="departments-style-two alternat-2 pub-dsclr">
          <div className="auto-container">
            <div className="row clearfix">
              {departments
                .filter(
                  (dept) =>
                    dept?.department_name !== "Right To Information" &&
                    dept?.department_name !== "माहितीचा अधिकार"
                )
                .map((dept) => (
                  <div
                    className="col-lg-4 col-md-12 col-sm-12 departments-block"
                    key={dept.id}
                  >
                    <div className="departments-block-two">
                      <div className="inner-box">
                        <div className="content-box">
                          <h5>
                            <Link
                              to={
                                dept?.department_name === "General Admin Department" ||
                                  dept?.department_name === "सामान्य प्रशासन विभाग"
                                  ? "/general-admin-department"
                                  : `${dept?.department_link}`
                              }
                              state={{ id: dept?.p_id }}
                            >
                              {dept?.department_name}
                            </Link>
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default PublicDisclosure;
